export const ArrowBack = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className || ''}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.7161 9.41333H3.54948L10.1328 2.83C10.3828 2.58 10.3828 2.16333 10.1328 1.91333C9.88281 1.66333 9.46615 1.66333 9.21615 1.91333L1.54948 9.58C1.46615 9.74666 1.38281 9.83 1.38281 9.99666C1.38281 10.1633 1.46615 10.33 1.54948 10.4133L9.13281 17.9967C9.21615 18.08 9.38281 18.1633 9.54948 18.1633C9.71615 18.1633 9.88281 18.08 9.96615 17.9967C10.2161 17.7467 10.2161 17.33 9.96615 17.08L3.46615 10.58H18.6328C18.9661 10.58 19.2995 10.33 19.2995 9.91333C19.2995 9.49666 19.0495 9.41333 18.7161 9.41333Z"
                fill="#202020"
            />
        </svg>
    );
};
